export default class ExpectedErrorResponseError extends Error {}
